<template>
  <div>
    <!--blog Section start-->
    <div class="page-margin">
      <!--breadcrumb start-->
      <div class="breadcrumb-bg">
        <div class="container">
          <div class="row">
            <div class="col-md-6 col-sm-6 col-text-center d-align-center">
              <h2 class="title"><span>Nossa</span> História</h2>
            </div>
          </div>
        </div>
      </div>
      <!--breadcrumb end -->
      <!-- blog Section starts -->
      <section id="business" class="business" style="padding-top: 10px;">
        <div class="container">
          <div class="row">
            <div class="col-sm-12">
              <div class="blog-item">
                <div class="blog-text">
                  <div class="blog-description">
                    <p>A Prodo Sistemas nasceu da necessidade e do propósito de atender os clientes e parceiros 
                      de maneira mais eficaz, oferecendo uma ferramenta prática e confiável, que valoriza a 
                      eficiência e a qualidade nos negócios. Nossos sistemas são totalmente intuitivos, 
                      proporcionando soluções simples e eficientes para a gestão de micro e pequenas empresas.</p>
                    <p>Valorizamos sempre a ética e a humanização em todos os processos, garantindo um canal de 
                      comunicação direto e a possibilidade de crescimento mútuo junto aos nossos parceiros, 
                      maximizando a satisfação de todos os envolvidos. Nosso nome, PRODO (Pró-dom), reflete nossa 
                      missão de ajudar as empresas a potencializarem seus talentos.</p>
                  </div>
                </div>
              </div>
              <div class="blog-item">
                <div class="blog-text">
                  <a href="#">
                    <h3 class="blog-head">Portfólio</h3>
                  </a>
                  <div class="blog-divider"></div>
                  <div class="blog-description">
                    <p>No mundo e no mercado atual, a busca por otimização do tempo, praticidade e eficiência é 
                      constante. É exatamente isso que a PRODO SISTEMAS oferece. Fornecemos soluções de automação 
                      comercial para diversos setores de empresas, como alimentício, transporte, restaurantes, pets, 
                      cosméticos, confecção têxtil, entre outros.</p>
                    <p>Buscamos atender nossos parceiros e clientes de forma abrangente e completa, fornecendo uma 
                      ferramenta de qualidade, com suporte especializado e humanizado, gerando satisfação e 
                      crescimento mútuo.     <br><br>
                      Especializada em automação comercial, a Prodo Sistemas oferece ao mercado soluções 
                      inovadoras em software para micro e pequenas empresas em todo o Brasil.</p>
                  </div>
                </div>
              </div>
              <div class="blog-divider"></div>
              <div class="reply-comment">
                <div class="media">
                  <img class="align-self-top mr-3" :src='"../assets/images/icon/vision.png"' width="100" alt="blog">
                  <div class="media-body">
                    <router-link :to="{ name: 'Blog_details' }">
                      <h5 class="mt-0">Visão</h5>
                    </router-link>
                    <p>Nosso objetivo é consolidar nossa excelência no desenvolvimento de software e automação 
                      comercial para pequenas e médias empresas em todo o país.
                    </p>
                  </div>
                </div>
                <div class="media">
                  <img class="align-self-top mr-3" :src='"../assets/images/icon/mission.png"' width="100" alt="blog">
                  <div class="media-body">
                    <router-link :to="{ name: 'Blog_details' }">
                      <h5 class="mt-0">Missão</h5>
                    </router-link>
                    <p>Nossa missão é satisfazer plenamente clientes e parceiros no ramo de automação comercial, 
                      fornecendo ferramentas práticas e de qualidade, acompanhando a evolução do mercado e 
                      proporcionando crescimento e rentabilidade aos nossos parceiros e consumidores finais.</p>
                  </div>
                </div>
                <div class="media">
                  <img class="align-self-top mr-3" :src='"../assets/images/icon/values.png"' width="100" alt="blog">
                  <div class="media-body">
                    <router-link :to="{ name: 'Blog_details' }">
                      <h5 class="mt-0">Valores</h5>
                    </router-link>
                    <p>Ética, Qualidade, Confiabilidade, Agilidade, Comprometimento e Dedicação</p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <!--blog Section End-->
      <Footer />
      <js />

    </div>
  </div>
</template>
<script>
export default {
  name: 'Blog_details'
}
</script>
<style scoped>.fun-fact__title {
  color: #18e7d3;
}</style>



// WEBPACK FOOTER //
// src/components/blog_details.vue